import { render, staticRenderFns } from "./EditIP-address.vue?vue&type=template&id=0c7d2f78"
import script from "./EditIP-address.vue?vue&type=script&lang=js"
export * from "./EditIP-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports